import classNames from 'classnames'

import ChevronDownIcon from '../assets/icons/chevron-down.svg?react'
import { IconComponent, Option } from '../types'

type SelectProps = React.SelectHTMLAttributes<HTMLSelectElement> & {
  options: Option[]
  block?: boolean
  prefix?: React.ReactNode
  prefixIcon?: IconComponent
  className?: string
  placeholder?: string
  invalid?: boolean
}

export const Select: React.FC<SelectProps> = ({
  block,
  prefix,
  prefixIcon: PrefixIcon,
  className,
  options,
  placeholder,
  invalid,
  ...selectProps
}) => {
  return (
    <div
      className={classNames(
        className,
        'inline-flex bg-neutralBlack-50 rounded-lg border  outline-none relative',
        invalid
          ? 'border-danger placeholder:text-danger focus-within:border-danger'
          : 'border-neutralBlack-50 placeholder:to-neutralBlack-300 focus-within:border-neutralBlack-400',
        { 'w-full': block, 'opacity-50 pointer-events-none': selectProps.disabled }
      )}
    >
      {(prefix || PrefixIcon) && (
        <div className="flex items-center justify-center h-12">
          {prefix || (PrefixIcon && <PrefixIcon className="size-6 ml-4 opacity-50" />)}
        </div>
      )}

      <select
        {...selectProps}
        className="bg-transparent h-12 px-4 outline-none flex-auto appearance-none pr-12"
      >
        {placeholder && (
          <option value={undefined} disabled>
            {placeholder}
          </option>
        )}

        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>

      <div className="flex items-center justify-center h-12 absolute right-0">
        <ChevronDownIcon className="size-4 mr-4 opacity-50" />
      </div>
    </div>
  )
}
